import { Route, Switch } from "react-router-dom";

import BrandComponent from "../../components/page/commission/BrandComponent";
import InfluencerComponent from "../../components/page/commission/InfluencerComponent";
import SellerComponent from "../../components/page/commission/SellerComponent";

const CommissionPage = () => {
  return (
    <Switch>
      <Route path="/commission/brand" component={BrandComponent} />
      <Route path="/commission/influencer" component={InfluencerComponent} />
      <Route path="/commission/seller" component={SellerComponent} />
    </Switch>
  );
};

export default CommissionPage;
